'use client';

import { useEffect } from 'react';

export function HeaderActions() {
  useEffect(() => {
    document.addEventListener('keydown', handleKeyboardShortcuts);

    return () => {
      document.removeEventListener('keydown', handleKeyboardShortcuts);
    };
  }, []);

  return null;
}

function handleKeyboardShortcuts(e: KeyboardEvent) {
  switch (true) {
    case e.shiftKey && e.ctrlKey && e.code === 'KeyQ':
      signOut();
      break;
    case e.altKey && e.ctrlKey && e.key === '1':
      location.href = '/admin/dashboard';
      break;
    case e.altKey && e.ctrlKey && e.key === '2':
      location.href = '/admin/users';
      break;
    case e.altKey && e.ctrlKey && e.key === '3':
      location.href = '/admin/partners';
      break;
    case e.altKey && e.ctrlKey && e.key === '4':
      location.href = '/admin/payouts';
      break;
    case e.altKey && e.ctrlKey && e.key === '5':
      location.href = '/outstatic';
      break;
    case e.altKey && e.ctrlKey && e.key === '6':
      location.href = '/admin/messages';
      break;
    case e.altKey && e.ctrlKey && e.key === '7':
      location.href = '/admin/promotion-codes';
      break;
    case e.altKey && e.ctrlKey && e.key === '8':
      location.href = '/admin/sms-logs';
      break;
  }
}

type ClickHandlerProps = {
  children: React.ReactNode;
};

// Sign out functions
export function SignOutClickHandler({ children }: ClickHandlerProps) {
  return <div onClick={() => signOut()}>{children}</div>;
}

function signOut() {
  const signOutButton = document.getElementById('sign-out-button');

  signOutButton?.click();
}
